const XLSX = require('xlsx');
const Validation = require('./Validation');
const Type = require('./Type');
const Parser = require('./Parser');

class Sheet {
  constructor(file, fileName, xlsxOptions = {}) {
    this._file = file;
    this._fileName = fileName;
    this._xlsxOptions = xlsxOptions;
    this._workbook = this._buildWorkbook();
    this._data = this._getData();
    this._parser = new Parser(this._data);
  }

  validate() {
    return new Validation(this._workbook, this._data).validate();
  }

  getType() {
    return new Type(this._data).get();
  }

  getItems() {
    return this._parser.getItems();
  }

  _getData() {
    return XLSX.utils.sheet_to_json(this._getSheet(), {
      header: 1
    });
  }

  _getSheet() {
    return this._workbook.Sheets[Object.keys(this._workbook.Sheets)[0]];
  }

  _getExt() {
    return this._fileName.split('.').pop();
  }

  _buildWorkbook() {
    const isCSV = this._getExt() === 'csv';
    this._file = isCSV ? this._file.toString('utf8') : this._file;
    const type = isCSV ? 'string' : 'buffer';

    return XLSX.read(
      this._file,
      Object.assign(
        {
          type,
          raw: true,
          cellDates: true
        },
        this._xlsxOptions
      )
    );
  }
}

module.exports = Sheet;
